import styled from "styled-components";
import {GAME_NAVBAR_SPACE_BETWEEN_ITEMS} from "../../../../navbar/game-navbar-css-constants";

export const HybridEmbeddedGameLoadingIndicatorHeaderBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    align-content: flex-end;
    width: 100%;
    padding: 4px ${GAME_NAVBAR_SPACE_BETWEEN_ITEMS()} 4px 4px;
    
`